module.exports = __webpack_public_path__ + "5b2578b76a24576e9749430cedca9104.pdf";